import { render, staticRenderFns } from "./fryerStates.vue?vue&type=template&id=4a88e140&scoped=true"
import script from "./fryerStates.vue?vue&type=script&lang=js"
export * from "./fryerStates.vue?vue&type=script&lang=js"
import style0 from "./fryerStates.vue?vue&type=style&index=0&id=4a88e140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a88e140",
  null
  
)

export default component.exports